enum ItemsPremission {
  Prem_Items_Get_List = 'Prem_Items_Get_List',
  Prem_Items_Open_Page = 'Prem_Items_Open_Page',
  Prem_Items_Show_Full_Summary = 'Prem_Items_Show_Full_Summary',
  Prem_Items_Show_Discounts = 'Prem_Items_Show_Discounts',
  Prem_Items_Reset_Items_Cache = 'Prem_Items_Reset_Items_Cache',
  Prem_Items_Show_Items_Trans = 'Prem_Items_Show_Items_Trans',
  Prem_Items_Show_Items_Total = 'Prem_Items_Show_Items_Total',
  Prem_Items_Order_Report = 'Prem_Items_Order_Report',
  Prem_Items_Order_Report_Show_Count = 'Prem_Items_Order_Report_Show_Count',
  Prem_Items_Shortcomings_Report = 'Prem_Items_Shortcomings_Report',
  Prem_Items_Edit = 'Prem_Items_Edit',
  Prem_Items_Add_Paper = 'Prem_Items_Add_Paper',
  Prem_Items_Edit_Remove_Paper = 'Prem_Items_Edit_Remove_Paper',
  Prem_Items_Edit_Logs = 'Prem_Items_Edit_Logs',
  Prem_Items_Files = 'Prem_Items_Files',
  Prem_Items_Companies_Report = 'Prem_Items_Companies_Report',
  Prem_Items_Batch_Tracker = 'Prem_Items_Batch_Tracker',
  Prem_Items_Sedo_Fedren_Report = 'Prem_Items_Sedo_Fedren_Report',
}

export default ItemsPremission;
